<template>
    <div class="faq-view">
        <div class="animated fadeIn">
            <component-header
                title="FAQS"
                :isLoading="loading"
                :hasReload="true"
                :hasCreate="false"
                @reload-data="fetchData"
            />
            <div v-if="loading" class="loading-container">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                />
            </div>
            <div v-else>
                <b-card border-variant="info" class="card-wrap">
                    <div v-if="faqs && faqs.length > 0">
                        <div
                            role="tablist"
                            v-for="(item, index) in faqs"
                            :key="item.id"
                            class="box"
                        >
                            <b-card no-body class="mb-1">
                                <b-card-header
                                    header-tag="header"
                                    class="p-1 accord_head"
                                    role="tab"
                                >
                                    <div
                                        block
                                        v-b-toggle="'accordion' + item.item_id"
                                    >
                                        <b-col
                                            @click="toggleItem(index)"
                                            v-bind:href="'#collapse' + index"
                                        >
                                            <span class="topic-text">{{
                                                item.Topic
                                            }}</span>

                                            <i
                                                :class="[
                                                    isActive(index)
                                                        ? 'fa-minus'
                                                        : 'fa-plus',
                                                ]"
                                                class="more-less fa float-right"
                                            ></i>
                                        </b-col>
                                    </div>
                                </b-card-header>
                                <b-collapse
                                    :id="'accordion' + item.item_id"
                                    accordion="my-accordion"
                                    role="tabpanel"
                                    style
                                >
                                    <b-row>
                                        <b-col>
                                            <b-card-body>{{
                                                item.Description
                                            }}</b-card-body>
                                        </b-col>
                                        <b-col>
                                            <b-card-body
                                                v-if="
                                                    item.mediaType === 'IMAGE'
                                                "
                                                class="media-content-body"
                                            >
                                                <img
                                                    v-bind:src="
                                                        item.mediaContent
                                                    "
                                                    class="faq-media-image"
                                                />
                                            </b-card-body>
                                        </b-col>
                                    </b-row>
                                </b-collapse>
                            </b-card>
                        </div>
                    </div>
                    <div class="text-center" v-else>
                        <div>No data available!</div>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import cTable from "@/views/base/Table.vue";
import { AtomSpinner } from "epic-spinners";

export default {
    name: "ViewItem",
    components: {
        ComponentHeader,
        cTable,
        AtomSpinner,
    },
    data() {
        return {
            faq: {},
            toggled: [],
            loading: false,
        };
    },
    computed: {
        faqs() {
            let data = this.$store.getters["faq/GetFaqList"];
            let faqList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    for (let i = 0; i < obj.items.length; i++) {
                        let arrayObj = {
                            _id: obj._id,
                            category: obj.category,
                            Topic: obj.items[i].topic,
                            Description: obj.items[i].description,
                            mediaType: obj.items[i].media.mediaType,
                            mediaContent: obj.items[i].media.mediaContent,
                            item_id: obj.items[i]._id,
                            flag: false,
                            ...obj,
                        };
                        faqList.push(arrayObj);
                    }
                });
                return faqList;
            }
            return [];
        },
    },
    methods: {
        getDataObj() {
            try {
                const userLogin = JSON.parse(
                    sessionStorage.getItem("userLogin") || "{}",
                );
                return userLogin?.role === "Tenant"
                    ? { scope: "TENANT" }
                    : { scope: "PARTNER" };
            } catch {
                return { scope: "PARTNER" };
            }
        },
        async fetchData() {
            this.loading = true;
            try {
                const data = await this.$store.dispatch(
                    "faq/fetchFaqs",
                    this.getDataObj(),
                );
                if (data?.message) {
                    this.$toasted?.error(data.message);
                }
            } catch (error) {
                console.error("Failed to fetch FAQs:", error);
                const msg =
                    typeof error?.message === "string"
                        ? error.message
                        : error?.message?.message || "Failed to load FAQs";
                this.$toasted?.error(msg);
            } finally {
                this.loading = false;
            }
        },
        isActive(item) {
            return this.toggled.indexOf(item) >= 0;
        },
        toggleItem(item) {
            const index = this.toggled.indexOf(item);
            if (index >= 0) {
                this.toggled.splice(index, 1);
                return;
            }

            this.toggled.push(item);
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>

<style scoped>
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
}

[data-font="20"] {
    font-size: 20px;
}

.more-less {
    margin-top: 6px;
}

.accord_head {
    padding: 14px 4px !important;
}

::v-deep .box .card {
    border-radius: 4px;
}

::v-deep .box .card-header {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.topic-text {
    color: black;
}

.media-content-body {
    display: flex;
    justify-content: center;
    align-items: center;
}

.faq-media-image {
    height: 200px;
    width: 450px;
    max-width: 100%;
    object-fit: contain;
}

@media (max-width: 767.98px) {
    .float-left,
    .float-right,
    .right {
        width: 100%;
        text-align: end !important;
    }
    .more-less {
        margin-top: -15px;
    }
    .faq-media-image {
        height: auto;
        width: 100%;
        max-width: 100%;
    }

    .topic-text {
        font-size: 0.9rem;
    }
}
</style>
